import { render, staticRenderFns } from "./hpTitle.vue?vue&type=template&id=6820b5f6&scoped=true&"
import script from "./hpTitle.vue?vue&type=script&lang=js&"
export * from "./hpTitle.vue?vue&type=script&lang=js&"
import style0 from "./hpTitle.vue?vue&type=style&index=0&id=6820b5f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6820b5f6",
  null
  
)

export default component.exports